<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
      <defs>
      </defs>
      <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
      <g>
        <path class="cls-3" d="M61.91,49.86c-.59,.86-1.11,1.77-1.78,2.56-2.37,2.82-5.39,4.52-9.05,5.02-.9,.12-1.81,.13-2.72,.15-1.41,.02-2.82,0-4.28,0v.42c0,1.45,0,2.9,0,4.35-.01,3.46-2.65,6.37-6.1,6.71-.22,.02-.44,0-.68,0V28.79c.07,0,.12-.03,.18-.03,4.1,0,8.21-.06,12.31,.03,3.28,.07,6.16,1.31,8.66,3.42,1.14,.97,2.1,2.09,2.9,3.36,.12,.2,.12,.33,0,.53-1.24,2.12-1.79,4.43-1.71,6.87,.09,2.48,.79,4.78,2.27,6.81v.07Zm-17.81,.89h.44c1.47,0,2.95,.02,4.42-.01,.64-.01,1.3-.08,1.93-.23,3.69-.93,6.27-4.29,5.77-8.26-.49-3.88-3.73-6.68-7.65-6.68h-4.91v15.18Z"/>
        <path class="cls-3" d="M34.54,50.75v6.82c-.11,0-.2,.02-.29,.02-2.7,0-5.41,.04-8.11-.02-3.4-.08-6.4-1.27-8.98-3.49-2.64-2.27-4.29-5.14-4.83-8.57-.68-4.31,.38-8.19,3.16-11.56,2.26-2.73,5.18-4.39,8.68-5.01,.64-.11,1.29-.17,1.94-.18,2.72-.02,5.43,0,8.15,0,.08,0,.17,0,.28,.02v6.79h-.43c-2.49,0-4.99-.04-7.48,0-3.2,.06-5.57,1.54-6.96,4.43-2.05,4.26,.45,9.36,5.12,10.5,.64,.16,1.31,.23,1.96,.24,2.46,.03,4.91,.01,7.37,.01h.43Z"/>
        <path class="cls-2" d="M73.16,32.34c.34,.05,.68,.11,1.03,.14,1.25,.14,2.46,.45,3.62,.97-.42,1.08-.83,2.14-1.25,3.22-1.17-.53-2.4-.7-3.65-.78-3.17-.18-5.81,1.68-6.57,4.75-.57,2.29-.3,4.47,1.26,6.34,1.38,1.66,3.23,2.32,5.36,2.28,1.29-.02,2.54-.25,3.74-.84,.42,1.09,.83,2.15,1.25,3.25-.8,.44-1.66,.7-2.54,.86-2.4,.43-4.78,.39-7.07-.53-.71-.28-1.39-.63-2.04-1.04-.6-.39-1.17-.84-1.67-1.36s-.92-1.07-1.28-1.67-.67-1.3-.89-1.99c-.31-.97-.47-2-.51-3.02-.04-1.01,.06-2.02,.3-3,.17-.72,.45-1.43,.79-2.08s.74-1.27,1.21-1.83,.98-1.04,1.55-1.48,1.17-.8,1.81-1.11,1.31-.54,1.99-.71c.3-.07,.6-.14,.91-.18,.39-.06,.78-.13,1.17-.2h1.48Z"/>
      </g>
    </svg>
</template>

<script>
export default {
    name: "CpcDashIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #085c71;
  }
  .cls-3 {
    fill: #59c5c7;
  }
</style>
